/* Copyright 2021, Milkdown by Mirone. */
import { themeToolCtx } from '@milkdown/core';
import { Decoration } from 'prosemirror-view';
import { selectLine, selectTable } from '../utils';
import { ToolTipPos } from './constant';
const calculateClassName = (pos) => {
    switch (pos) {
        case ToolTipPos.Left: {
            return 'milkdown-cell-left';
        }
        case ToolTipPos.Top: {
            return 'milkdown-cell-top';
        }
        case ToolTipPos.Point:
        default: {
            return 'milkdown-cell-point';
        }
    }
};
export function createWidget(ctx, cell, pos, index = 0) {
    const widget = Decoration.widget(cell.pos + 1, (view) => {
        const div = document.createElement('div');
        div.classList.add(calculateClassName(pos));
        if (pos === ToolTipPos.Point) {
            div.appendChild(ctx.get(themeToolCtx).slots.icon('select'));
        }
        div.addEventListener('mousedown', (e) => {
            if (!view)
                return;
            e.preventDefault();
            switch (pos) {
                case ToolTipPos.Point: {
                    view.dispatch(selectTable(view.state.tr));
                    return;
                }
                case ToolTipPos.Left: {
                    view.dispatch(selectLine('row')(index)(view.state.tr));
                    return;
                }
                case ToolTipPos.Top: {
                    view.dispatch(selectLine('col')(index)(view.state.tr));
                    return;
                }
            }
        });
        return div;
    });
    return widget;
}
//# sourceMappingURL=widget.js.map